import styled, { css } from 'styled-components';

export const FirmDescriptionStyle = styled.div`
  flex-shrink: 1;
  max-width: ${({ mw }) => mw}px;
  @media screen and (max-width: 1039px) {
    display: none;
  }

  ${({ location }) => {
    return location === 'sale' || location === 'rent' || location === 'archive'
      ? css`
          @media screen and (max-width: 1069px) {
            display: none;
          }
        `
      : null;
  }}
`;
